<style>
  @keyframes stripe-march {
    0% {
      background-position: 0 0;
    }

    100% {
      background-position: 12px 12px;
    }
  }

  .stripe-animated {
    background-size: 12px 12px;
    animation: stripe-march 0.8s linear infinite;
  }
</style>

<table class="w-full">
  <thead>
    <tr class="border-b border-gray-200">
      <!-- CHANGE-HIGHLIGHT-BORDER GAUCHE : header de colonne (vide, largeur fixée) -->
      <th class="p-0 w-[8px] min-w-[8px] max-w-[8px]"></th>

      <!-- Colonne Actions conditionnelle -->
      @if (showActions) {
      <th class="py-0 px-4 font-medium text-sm text-center text-gray-600 cursor-default">
        {{ 'Actions' | translate }}
      </th>
      }

      @for (col of dataColumns(); track $index) {
      <th (click)="sort(col.key || '')" [attr.data-testid]="'col-' + (col.key || '')" class="py-1 px-2 font-medium text-sm"
        [ngClass]="visibilityClass(col)"
        [class.text-blue-600]="sortableColumns?.includes(col.key || '') && col.sortable"
        [class.text-gray-600]="!sortableColumns?.includes(col.key || '') || !col.sortable"
        [class.cursor-pointer]="sortableColumns?.includes(col.key || '') && col.sortable"
        [class.cursor-default]="!sortableColumns?.includes(col.key || '') || !col.sortable"
        [class.text-left]="col.align === 'left'" [class.text-center]="col.align === 'center'"
        [class.text-right]="col.align === 'right'">

        {{ col.title }}
        @if (sortBy === col.key) {
        <span>{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
        }
      </th>
      }

      <!-- CHANGE-HIGHLIGHT-BORDER DROIT : header de colonne (vide, largeur fixée) -->
      <th class="p-0 w-[4px] min-w-[4px] max-w-[4px]"></th>
    </tr>
  </thead>

  <tbody>
    @for (entity of entities; track entity.id; let i = $index) {
    <tr class="relative border-b border-gray-100"
      [attr.data-testid]="'row-' + entity.id"
      [attr.data-state]="entity._entityState"
      [ngClass]="{
    'bg-gray-300 hover:bg-gray-200 text-gray-900': entity.id === selectedId,
    'hover:bg-gray-100': entity.id !== selectedId,
    'opacity-50': isInactive(entity)
  }"
      [style.background-image]="entity._entityState === EntityState.Deleted ? 'repeating-linear-gradient(-45deg, #fef2f2 0px, #fef2f2 6px, #fee2e2 6px, #fee2e2 12px)': 'none'"
      style="content-visibility: auto; contain-intrinsic-size: auto 37px;"
      (contextmenu)="onRightClick($event, entity)"
      (click)="selectItem(entity.id)">

      <td class="p-0 w-[8px] min-w-[8px] max-w-[8px] align-middle relative"
        [class.bg-purple-300]="entity._entityState === EntityState.Modified"
        [class.bg-red-300]="entity._entityState === EntityState.Deleted"
        [class.bg-green-300]="entity._entityState === EntityState.Added">
        @if (entity._entityState && entity._entityState !== EntityState.Unchanged) {
        <div class="absolute inset-0 stripe-animated cursor-help"
          [style.background]="getStripeGradient(entity._entityState)"
          [appRichTooltip]="tooltipTemplate"
          [tooltipContext]="getTooltipContext(entity)"
          tooltipAlignment="center"
          [tooltipDelay]="200"
          [tooltipHideDelay]="300"
          (mouseenter)="startAutoDismissTimer(entity)">
        </div>
        }
      </td>

      <!--  CELLULE ACTIONS  -->
      @if (showActions) {
      <td class="py-0 px-4 whitespace-nowrap text-sm text-center">
        <div class="flex space-x-2 justify-center">
          <button (click)="onEdit(entity, $event)" [attr.data-testid]="'row-edit-' + entity.id"
            [class.opacity-50]="!canEdit(entity)"
            [class.cursor-not-allowed]="!canEdit(entity)"
            class="text-blue-400 hover:text-blue-600 focus:outline-none">
            <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2">
              <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
            </svg>
          </button>
          <button (click)="onDelete(entity, $event)" [attr.data-testid]="'row-delete-' + entity.id"
            class="text-red-400 hover:text-red-600 focus:outline-none">
            <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
      </td>
      }

      <!-- COLONNES DE DONNÉES -->
      @for (col of dataColumns(); track $index) {
      @if (col.visible !== 'false') {
      <td class="relative py-2 px-4 whitespace-nowrap text-sm"
        [ngClass]="visibilityClass(col)"
        [class.text-left]="col.align === 'left'"
        [class.text-center]="col.align === 'center'"
        [class.text-right]="col.align === 'right'">

        @switch (col.type) {
        @case ('text') {
        <span class="text-gray-900">{{ getNestedValue(entity, col?.key || '') }}</span>
        }
        @case ('boolean') {
        <span class="text-gray-900">{{ getNestedValue(entity, col?.key || '') ? '✓' : '✗' }}</span>
        }
        @case ('date') {
        @if (getNestedValue(entity, col?.key || ''); as valeur) {
        <span class="text-gray-900">{{ getFormatedDateValue(valeur) }}</span>
        @if (fuseauDeLigne(entity); as iana) {
        <app-timezone-icon class="ml-1" [iana]="iana"></app-timezone-icon>
        }
        }
        }
        @case ('datetime') {
        @if (getNestedValue(entity, col?.key || ''); as valeur) {
        <span class="text-gray-900">{{ getFormatedDateTimeValue(valeur) }}</span>
        @if (fuseauDeLigne(entity); as iana) {
        <app-timezone-icon class="ml-1" [iana]="iana"></app-timezone-icon>
        }
        }
        }
        @case ('progress') {
        <div>
          <div class="w-full bg-gray-200 rounded-full h-1.5">
            <div class="bg-blue-600 h-1.5 rounded-full"
              [style.width]="getNestedValue(entity, col?.key || '') + '%'"></div>
          </div>
          <span class="text-gray-900">{{ getNestedValue(entity, col?.key || '') }}%</span>
        </div>
        }
        @case ('custom') {
        <ng-container [ngTemplateOutlet]="col.customTemplate!"
          [ngTemplateOutletContext]="{ $implicit: entity }"></ng-container>
        }
        }

        <!-- Indicateur local de propriété -->
        @if (entity._modifiedProperties?.has(col?.key || '') && entity._entityState === EntityState.Modified) {
        <span class="absolute right-0 top-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full bg-orange-400"
          title="{{ 'Modified' | translate }}"></span>
        }
      </td>
      }
      }
      <td class="p-0 w-[4px] min-w-[4px] max-w-[4px] align-middle relative"
        [class.bg-purple-300]="entity._entityState === EntityState.Modified"
        [class.bg-red-300]="entity._entityState === EntityState.Deleted"
        [class.bg-green-300]="entity._entityState === EntityState.Added">
        @if (entity._entityState && entity._entityState !== EntityState.Unchanged) {
        <div class="absolute inset-0 stripe-animated cursor-help"
          [style.background]="getStripeGradient(entity._entityState)"
          [appRichTooltip]="tooltipTemplate"
          [tooltipContext]="getTooltipContext(entity)"
          tooltipAlignment="center"
          [tooltipDelay]="200"
          [tooltipHideDelay]="300"
          (mouseenter)="startAutoDismissTimer(entity)">
        </div>
        }
      </td>

    </tr>
    }
  </tbody>
</table>

<app-context-menu [visible]="contextMenuVisible()"
  [position]="contextMenuPosition()"
  [menuItems]="effectiveMenuItems()"
  (hide)="hideContextMenu()">
</app-context-menu>